<template>
  <TheUncle :color="true" title="접수 목록" description="아직 승인 처리되지 않는 사입 목록입니다.">
    <a-card>
      <a-checkbox
        :indeterminate="
          users.length !== checklist.length && checklist.length > 0
        "
        :checked="users.length === checklist.length"
        @change="onCheckboxAll"
      >전체 선택</a-checkbox>
      <a-row>
        <a-col :span="24" v-for="user in users" :key="user.idx">
          <a-checkbox :checked="checklist.includes(user.idx)" @click="onCheckbox(user.idx)">
            {{ user.username }}({{ user.identity }}) -
            <a-badge :count="saibs[user.idx].length + '개'" />
          </a-checkbox>
        </a-col>
      </a-row>
    </a-card>
    <a-input v-model="reason" placeholder="실패시 사유를 입력해주세요." style="margin-top: 0.5em;" />
    <a-row class="fl-right mt" :gutter="12">
      <a-col :span="12">
        <a-button @click="onDelete" type="danger" icon="delete">삭제</a-button>
      </a-col>
      <a-col :span="12">
        <a-button @click="onApply" type="primary" icon="save">접수</a-button>
      </a-col>
    </a-row>
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "UncleUnprocessed",
  components: { TheUncle },
  mounted() {
    this.refreshUnprocessed();
  },
  methods: {
    ...mapActions(["uncleRefreshMe"]),
    onCheckboxAll() {
      if (this.checklist.length > 0) this.checklist = [];
      else this.users.forEach(v => this.checklist.push(v.idx));
    },
    onCheckbox(idx) {
      if (this.checklist.includes(idx)) {
        const bak = this.checklist;
        this.checklist = [];
        for (const item of bak) {
          if (item === idx) continue;
          this.checklist.push(item);
        }
      } else {
        this.checklist.push(idx);
      }
    },
    async refreshUnprocessed() {
      try {
        this.saibs = {};
        this.users = [];
        this.checklist = [];
        const { data } = await Axios.get(
          `${config.hostname}/v1/uncle/saib/unprocessed`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.users = _.uniqBy(data.saibs, "account.idx").map(
                ({ account }) => {
                  this.saibs[account.idx] = [];
                  return account;
                }
              );

              for (const saib of data.saibs)
                this.saibs[saib.account.idx].push(saib);
              break;
          }
        }
      } catch (e) {
        config.alert.mixin({
          type: "error",
          title:
            "접수 목록 정보를 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.$forceUpdate();
    },
    async onApply() {
      try {
        for (const account of this.checklist) {
          const saibs = [];
          for (const { idx } of this.saibs[account]) {
            saibs.push(idx);
          }

          const { data } = await Axios.post(
            `${config.hostname}/v1/uncle/saib/unprocessed`,
            { saibs },
            { withCredentials: true }
          );

          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                config.alert.mixin({
                  type: "success",
                  title: "성공적으로 반영하였습니다."
                });
                await this.uncleRefreshMe();
                await this.refreshUnprocessed();
                break;
              default:
                config.alert.mixin({
                  type: "error",
                  title: "알 수 없는 오류가 발생하였습니다."
                });
                break;
            }
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷에 연결할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
        throw err;
      }
    },
    async onDelete() {
      try {
        for (const account of this.checklist) {
          const saibs = [];
          for (const { idx } of this.saibs[account]) {
            saibs.push(idx);
          }

          const { data } = await Axios.delete(
            `${config.hostname}/v1/uㅇncle/saib/unprocessed`,
            {
              withCredentials: true,
              data: {
                reason: this.reason,
                saibs
              }
            }
          );

          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                config.alert.mixin({
                  type: "success",
                  title: "성공적으로 거절되었습니다."
                });
                this.reason = "";
                await this.uncleRefreshMe();
                await this.refreshUnprocessed();
                break;
              default:
                config.alert.mixin({
                  type: "error",
                  title: "알 수 없는 오류로 거절 할 수 없습니다."
                });
                break;
            }
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷에 연결할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    }
  },

  data() {
    return {
      users: [],
      saibs: {},
      checklist: [],
      reason: ""
    };
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>
